/**
 * LoadingSpinner Component
 * Full-screen loading indicator for initialization states
 *
 * Extracted from App.tsx for better organization and testability
 */

import React from 'react';
import { Loader2 } from 'lucide-react';

// ============================================================================
// Props Interface
// ============================================================================

export interface LoadingSpinnerProps {
  /** Primary loading message */
  message?: string;
  /** Secondary descriptive message */
  subMessage?: string;
}

// ============================================================================
// Component
// ============================================================================

/**
 * LoadingSpinner - Full-screen centered loading indicator
 *
 * Features:
 * - Animated spinning icon
 * - Customizable loading message
 * - Dark theme consistent with app design
 * - Centered vertically and horizontally
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Initializing vault...',
  subMessage = 'Setting up secure storage...'
}) => (
  <div className="min-h-screen bg-black text-white flex items-center justify-center">
    <div className="text-center">
      <Loader2 size={48} className="mx-auto mb-4 animate-spin text-purple-400" />
      <p className="text-lg text-gray-400">{message}</p>
      <p className="text-sm text-gray-600 mt-2">{subMessage}</p>
    </div>
  </div>
);

LoadingSpinner.displayName = 'LoadingSpinner';
